export default __webpack_public_path__ + "static/media/upload-failed.863d43d8.svg";